import { useEffect } from 'react';

/**
 * Custom hook for click on the DOM body
 *
 * @param {Function} onClick - Callback when body is clicked
 */
export default ({ onClick }) => {
	// FIXME: Temporarily disabled here. Still not sure I like it.
	return;
	useEffect(() => {
		const bodyClick = () => {
			onClick && onClick();
		};
		document.body.addEventListener('click', bodyClick);
		return () => {
			document.body.removeEventListener('click', bodyClick);
		};
	}, []);
};
